import { format, subDays } from 'date-fns'

/**
 * Computes the end date for the "completed days ago" filter.
 * Returns the date N days before the given date in 'yyyy-MM-dd' format.
 * Returns undefined if completedDaysAgo is null or 0 (filter disabled).
 */
export const computeEndDate = (
  completedDaysAgo: number | null,
  today: Date
): string | undefined => {
  if (!completedDaysAgo) {
    return undefined
  }
  return format(subDays(today, completedDaysAgo), 'yyyy-MM-dd')
}
